import React, { useEffect, useState } from "react";
import groupBy from "lodash/groupBy";
import { useIntl } from "react-intl";
import { useFormikContext } from "formik";
import { Button, Row, Space } from "@masterteam/mt-design-react";

import Collapse from "./Collapse";
import Table from "../../NewTable";
import ProjectForm from "./ProjectForm";
import { formatDate } from "../../../helpers";

import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/images/delete.svg";

import "./style.scss";

const initialModalState = {
  isOpen: false,
  data: null,
};

const Projects = ({ lists, isReadOnly }) => {
  const intl = useIntl();
  const isAr = intl.locale === "ar";
  const { values, setFieldValue } = useFormikContext();
  const [formModal, setFormModal] = useState(initialModalState);
  const [projects, setProjects] = useState(values.Projects);
  const [allWeights, setAllWeights] = useState(0);

  const projectsByProgram = groupBy(projects, "Program.ID");

  const columns = [
    {
      key: "Name",
      cell: (item) => (isAr ? item?.ArabicName : item?.EnglishName),
      header: intl.formatMessage({
        id: "project.name",
      }),
      width: "25%",
    },
    {
      key: "Duration",
      cell: (item) => item?.Duration,
      header: intl.formatMessage({
        id: "project.duration",
      }),
      width: "15%",
    },
    {
      key: "StartDate",
      cell: (item) => formatDate(item?.StartDate),
      header: intl.formatMessage({ id: "project.start-date" }),
      width: "15%",
    },
    {
      key: "FinishDate",
      cell: (item) => formatDate(item?.FinishDate),
      header: intl.formatMessage({ id: "project.end-date" }),
      width: "15%",
    },
    {
      key: "Budget",
      cell: (item) => item?.Budget,
      header: intl.formatMessage({
        id: "project.budget",
      }),
      width: "15%",
    },
    {
      key: "Weight",
      cell: (item) => `${item?.Weight}%`,
      header: intl.formatMessage({
        id: "project.weight",
      }),
      width: "15%",
    },
  ];

  const actions = [
    {
      key: "edit",
      variant: "primary",
      Icon: EditIcon,
      "tooltip-position": "buttom",
      tooltip: "Update",
      onClick: (item) => {
        setFormModal({ isOpen: true, data: item });
      },
    },
    {
      key: "delete",
      variant: "error",
      Icon: DeleteIcon,
      "tooltip-position": "buttom",
      tooltip: "Delete",
      onClick: (item) => {
        setProjects(projects.filter((e) => e.ID !== item.ID));
      },
    },
  ];

  useEffect(() => {
    setFieldValue("Projects", projects);
    setAllWeights(
      projects.reduce((acc, e) => {
        return acc + parseInt(e.Weight);
      }, 0)
    );
  }, [projects]);

  return (
    <div className="projects">
      <Row align="center" justify="between">
        <div className="title-wrapper">
          {intl.formatMessage({
            id: "initiative.projects",
          })}
        </div>

        {!isReadOnly && (
          <Button
            shape="round"
            onClick={() => setFormModal({ isOpen: true, data: null })}
          >
            {intl.formatMessage({ id: "common.add" })}
          </Button>
        )}
      </Row>

      <Space direction="vertical" size="large">
        {Object.keys(projectsByProgram).map((key) => (
          <Collapse
            program={projectsByProgram[key]?.[0]?.Program}
            programID={key}
            content={
              <Table
                data={projectsByProgram[key]}
                columns={columns}
                actions={isReadOnly ? [] : actions}
              />
            }
          />
        ))}
      </Space>

      {formModal.isOpen && (
        <ProjectForm
          data={formModal.data}
          lists={lists}
          projects={projects}
          allWeights={allWeights}
          setProjects={setProjects}
          closeModal={() => setFormModal(initialModalState)}
        />
      )}
    </div>
  );
};

export default Projects;
